export const questionType = {
	1: [
		{ label: '单选题', value: 1 },
		{ label: '多选题', value: 2 },
		{ label: '填空题', value: 3 },
		{ label: '连线题', value: 11 },
    { label: '排序题', value: 10 },
    // { label: '演唱题', value: 7 },
    { label: '节奏题', value: 4 },
		// { label: '可视化演唱题', value: 9 },
    { label: '演唱题', value: 9 },
    { label: '识音练习题', value: 18 },
    { label: '视唱旋律题', value: 5 },
    { label: '弹奏题', value: 24 },
	],
	2: [
		{ label: '单选题', value: 1 },
		{ label: '多选题', value: 2 },
		{ label: '填空题', value: 3 },
		{ label: '连线题', value: 11 },
    { label: '排序题', value: 10 },
    { label: '填充题', value: 12 },
		{ label: '拼图题', value: 13 },
		{ label: '配色题', value: 14 },
	]
}

export const scoreMap = [
  { title: -5.0, disabled: true },
  { title: -4.0, disabled: true },
  { title: -3.0, disabled: true },
  { title: -2.0, disabled: true },
  { title: -1.0, disabled: true },
  { title: 0.0, disabled: true  },
  { title: +1.0, disabled: true },
  { title: +2.0, disabled: true },
  { title: +3.0, disabled: true },
  { title: +4.0, disabled: true },
  { title: +5.0, disabled: true }
]
export const categoryMap = [
  { title: '纪律', id: 1, disabled: true },
  { title: '回答问题', id: 2, disabled: true },
  { title: '课堂活动', id: 3, disabled: true },
  { title: '课堂作业', id: 4, disabled: true },
  { title: '课后任务', id: 5, disabled: true }
]

export const paramsRules = {
  icon_path: [{ required: true, message: '请上传图标', trigger: ['blur', 'change'] }],
  title: [{ required: true, message: '名称不能为空', trigger: ['blur', 'change'] }],
  score: [{ required: true, message: '请选择分值', trigger: ['blur', 'change'] }],
  cate_id: [{ required: true, message: '请选择分类', trigger: ['blur', 'change'] }],
}

export const customValue = '自定义加减分'
